import { KeyboardArrowDown } from "@mui/icons-material";
import { Button, Dialog, InputBase, MenuItem, Select } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const ChangeOrgModal = ({ open, setOpen, user, changeOrganization, orgs  }) => {
    const navigate = useNavigate()
  return (
    <Dialog open={open} fullWidth={true} maxWidth={"sm"}
    
    
    BackdropProps={{
          style: { backgroundColor: "rgba(0, 0, 0, 0.2)" }, // Adjust opacity here
        }}
    >
      <div className="lg:px-8 px-4 py-14">
        <div className="lg:text-[20px] text-[#030229]  text-[15px] font-semibold  text-center mb-4">Alert !!</div>


        <div className="lg:text-[14px] text-[13px] text-center mb-2" >
       Youre no longer a member of <span className="font-bold">{JSON.parse(localStorage.getItem('organization'))?.organization_name?.S}</span> , please log out or select another org.
       You may reach out to Organization admin or owner to be added.
        </div>

        <div>
              <Select
                        IconComponent={KeyboardArrowDown}
                        fullWidth
                        value={
                          user?.relatedOrgs.L.filter(
                            (e) =>
                              e?.M.org_id.S ===
                              JSON.parse(localStorage.getItem("organization")).orgId.S
                          )[0]?.M.org_id.S
                        }
                        onChange={(f) => {
                          changeOrganization(f.target.value);
                        }}
                        className="mb-2 bg-[#F7F7F8]"
                        sx={{
                          fontSize: "13px",
                          padding: "2px 8px", // Adjust padding here
                          "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                          "& .MuiSelect-select": {
                            padding: "2px 8px", // Adjust padding for the text inside Select
                          },
                        }}
                      >
                        {user?.relatedOrgs.L.map((item, index) => {
                          return (
                            <MenuItem key={index} value={item.M.org_id.S}>{orgs?.find((e)=> e.orgId.S === item.M.org_id.S)?.organization_name.S}</MenuItem>
                          );
                        })}
                      </Select>
        </div>


        <div className="flex items-center justify-center space-x-3 mt-4">
        <Button
                  sx={{
                    textTransform: "none",
                    bgcolor: "rgba(236,72,92,0.1)",
                    color: "rgba(236,72,92,1)",
                    py: "6px",
                    px: "30px",
                    borderRadius: "7px",
                    
                    fontSize: { lg: "14px", xs: "13px" },
                    width: "fit",
                  }}
                  onClick={()=> {
                    
                    localStorage.clear()
                    navigate('/login')
                  }}
                >
                  Logout
                </Button>
                
        </div>


      
      </div>
    </Dialog>
  );
};

export default ChangeOrgModal;
